export default __webpack_public_path__ + "static/color-role-do-light-749d3ca931af3c330c1a9869f25d0c1d.png";